// src/pages/ShippingPolicy.js 
// (Assuming this file contains your ShippingPolicy component)

import React from "react";
import './ShippingPolicy.css'
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

import { Link } from "react-router-dom";

import Navbar from "../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../CommonComponent/Notification/NotificationBar";
import Footer from "../../CommonComponent/Footer/footer";

const ShippingPolicy = () => {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Shipping Policy - Marvel Lifestyle | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover our shipping policy and learn how quickly your order will arrive. Enjoy fast, reliable delivery every time you shop with us!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/shipping-policy`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Shipping Policy - Marvel Lifestyle" />
                <meta
                    property="og:description"
                    content="Discover our shipping policy and learn how quickly your order will arrive. Enjoy fast, reliable delivery every time you shop with us!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/shipping-policy`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <Navbar />
            <NotificationBar />
            <div className="ShippingPolicy_pg_wrapper">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title-LowerCase title-border">Shipping Policy – Marvel Lifestyle</h1>
                </div>
                <div className="ShippingPolicy_pg_content">
                    <ul>
                        <li>We do our best to ensure your order arrives on time. However, estimated fabrication and shipping timelines are not guaranteed and there may be a number of unforeseen reasons why your items may arrive later than the estimated date.</li>
                        <li>Because of size limitations imposed by our carriers, the maximum length for free Standard shipping is 2.7mtrs. Packing Length over 2.7 mtrs are available in many products, but will simply require that they ship via Freight, which incurs an additional cost.</li>
                        <li>You will be provided with a shipment tracking number when your order ships.</li>
                        <li>Your order may arrive in multiple packages and shipments, depending upon the type, quantity and weight of item(s) in your order.</li>
                        <li>We cannot be responsible for shipment delays caused by inclement weather, “Acts of God”, or other circumstances beyond our control.</li>
                        <li>All estimated delivery times indicated here are approximate, and are expressed in business days, excluding holidays.</li>
                        <li>If your delivery status shows delivered, and you have not received the product, please inform us within 24 hrs of such status change by reaching out to our customer support Helpline.</li>
                        <li>If there is any damage to the packaging on delivery, contact us immediately at <Link to="mailto:info@marvellifestyle.com">info@marvellifestyle.com</Link> or <Link to="mailto:order@marvellifestyle.com">order@marvellifestyle.com</Link></li>
                    </ul>
                    <h4>
                        Refund Policy :-
                    </h4>
                    <ul>
                        <li>Within <b className="italic-font">(48 Hours)</b> of delivery, in an unlikely event of damaged, defective or different item delivered to you, you can also return the product within <b className="italic-font">05 days</b> of delivery for full refund.</li>
                        <li>Please keep the item in its original condition, with brand outer box, MRP tags attached, user manual, warranty cards, and original accessories in manufacturer packaging for a successful return pick-up.</li>
                        <li>We may contact you to ascertain the damage or defect in the product prior to issuing refund/replacement.</li>
                        <li>In case of Refund, due to any reason of Default from Customer Side, All the bank Charges of Both side will be borne by the Customer.</li>
                        <li>No Refund will be allowed of Order Amount after the <b className="italic-font">02 Hours</b> of Payment or Production has been started whichever is earlier.</li>
                    </ul>
                    <h6>
                        Refund will be processed only if :-
                    </h6>
                    <h6>
                        It is determined that the product was not damaged while in your possession;
                    </h6>
                    <ul>
                        <li>The product is not different from what was shipped to you;</li>
                        <li>The product is returned in original condition (with brand’s/manufacturer’s box, MRP tag intact, user manual, warranty card and all the accessories therein).</li>
                        <li>Upon receipt of the returned product, we will fully examine it and notify you via e-mail, within a reasonable period of time, whether you are entitled to a replacement as a result of the defect. If you are eligible, we will send you a replacement product.</li>
                    </ul>
                    <h6>
                        It is determined that the product was not damaged while in your possession;
                    </h6>
                    <ul>
                        <li>For your assistance kindly contact our sales and customer care representative at <b className="italic-font"><br />Email: order@marvellifestyle.com <br />Phone: 9898161212</b></li>
                        <li>Cancellation of order must be received in writing (via email: <Link to="mailto:order@marvellifestyle.com">order@marvellifestyle.com</Link>)</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default ShippingPolicy;